import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import {
  FulfilmentDetail,
  FulfilmentType,
} from '../../../../../../models/fulfilment'
import { useAppSelector } from '../../../../../../state/hooks'
import { selectIsSaleCustomerContactInfoReviewed } from '../../../../../../state/slices/uiStateSlice'
import {
  CurrentView,
  ShouldFulfillOpt,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'
import { isMissingContactInfo } from '../LineItemFulfillmentUtils'

interface UseLineItemFulfillmentDecisionFlowProps {
  onFulfilmentDetailsSet: (fulfilmentDetails: FulfilmentDetail) => void
  onClose: () => void
  onBreakdownOuterPacks?: () => Promise<boolean>
}

export const useLineItemFulfillmentDecisionFlow = ({
  onFulfilmentDetailsSet,
  onClose,
  onBreakdownOuterPacks,
}: UseLineItemFulfillmentDecisionFlowProps) => {
  const t = useT()
  const {
    setCurrentView,
    currentDecision,
    currentCustomer,
    onSelectContinueAnyway,
    setCurrentDecision,
    isBreakdownSelected,
    setIsBreakdownSelected,
  } = useLineItemFulfillmentContext()

  const isContactInfoReviewed = useAppSelector(
    selectIsSaleCustomerContactInfoReviewed
  )

  const handleContinueFromDecisionView = async () => {
    if (currentDecision === ShouldFulfillOpt.YES) {
      if (currentCustomer) {
        if (isMissingContactInfo(currentCustomer) || !isContactInfoReviewed) {
          setCurrentView(CurrentView.REVIEW_CONTACT_INFO)
        } else {
          setCurrentView(CurrentView.FULFILMENT_METHOD)
        }
      } else {
        setCurrentView(CurrentView.ADD_CUSTOMER)
      }
    } else {
      // Handle both "Continue anyway" and "Break down" cases.
      if (isBreakdownSelected) {
        const isBreakdownSuccessful = await onBreakdownOuterPacks?.()
        if (!isBreakdownSuccessful) {
          ToastNotifications.negative(
            t('Sorry, we could not break down the product.', {
              _context: 'Toast Notification',
            })
          )
        }
      }

      if (onSelectContinueAnyway) {
        onSelectContinueAnyway()
      }
      onFulfilmentDetailsSet({
        type: FulfilmentType.UNSPECIFIED,
        note: '',
      })
      onClose()
    }
  }

  const handleDecisionSelect = (
    decision: ShouldFulfillOpt,
    isBreakdown: boolean = false
  ) => {
    setCurrentDecision(decision)
    setIsBreakdownSelected(isBreakdown)
  }

  return {
    handleDecisionSelect,
    handleContinueFromDecisionView,
  }
}
